<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="prev-page pr-1 prev"><a routerLink="/add-food-menu/{{vendorId}}">Create New Menu</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">View Menu</span>
        <!-- <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Plant Details</span> -->
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-0">View Menu</h2>
        <div class="d-flex column-gap-3">
            <button class="btn btn-cyan" (click)="goToBulkUploadPage()" *ngIf="foodvendorCreate">Bulk Upload</button>
            <button class="btn btn-primary" (click)="goToAddNewMenuItem()" *ngIf="foodvendorCreate">Add Menu Item</button>
        </div>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <p class="text-primary h5 font-weight-semibold">Vendor Name: {{vendorName}}</p>
    </div>

    <div class="filter_bar border-top border-bottom border-light mb-4 mb-md-5 mx-n5 px-5">
        <div class="row">

            <div class="col-12 col-md-6 col-lg-2 py-2 py-md-3 border-right border-light d-flex align-items-center">
                <svg-icon src="./assets/images/icons/sort_cyan.svg" class="field_icon"></svg-icon>
                <div [autoClose]="'outside'" [ngbPopover]="popContentType" triggers="manual" #r="ngbPopover"
                    (click)="openPopover(r)" (clickOutside)="onClickedOutside($event)" placement="bottom"
                    popoverClass="search_select_popover" class='py-0 px-0 w-100 pl-3'>
                    <span class="_popover_label">Food Type</span>
                    <span class="d-flex justify-content-end _popover_arrow">
                        <img src="/assets/images/Path.png" class="padding-left-image pr-3 justify-content-between" />
                    </span>
                    <div class="all">{{selectedMenuName}}</div>
                    <ng-template #popContentType>
                        <div class="popover_search">
                            <svg-icon src="/assets/images/icons/search.svg"></svg-icon>
                            <input type="text" placeholder='Search' [(ngModel)]="searchGroupSort" />
                        </div>
                        <div class="popover_content">
                            <div class="popover_items">
                                <div class="popover_item d-flex align-items-center justify-content-between"
                                    *ngFor="let menutype of getFilteredMenuTypes();let i=index"
                                    [ngClass]="multiSelectGroupType == menutype?.menuTypeName && 'active'"
                                    (click)="selectMenuType(menutype);">
                                    {{menutype?.menuTypeName}}
                                    <svg-icon src="/assets/images/icons/tick.svg"
                                        *ngIf="multiSelectGroupType == menutype?.menuTypeName"></svg-icon>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-2 py-2 py-md-3 border-right border-light d-flex align-items-center">
                <svg-icon src="./assets/images/icons/sort_cyan.svg" class="field_icon"></svg-icon>
                <div [autoClose]="'outside'" [ngbPopover]="popContentSortAva" triggers="manual" #q="ngbPopover"
                    (click)="openPopoverAvailable(q)" (clickOutside)="onClickedOutside($event)" placement="bottom"
                    popoverClass="search_select_popover" class='py-0 px-0 w-100 pl-3'>
                    <span class="_popover_label">Availability</span>
                    <span class="d-flex justify-content-end _popover_arrow">
                        <img src="/assets/images/Path.png" class="padding-left-image pr-3 justify-content-between" />
                    </span>
                    <div class="all">{{selectedMenuAvailableName}}</div>
                    <ng-template #popContentSortAva>
                        <div class="popover_search">
                            <svg-icon src="/assets/images/icons/search.svg"></svg-icon>
                            <input type="text" placeholder='Search' [(ngModel)]="searchGroupSortAva" />
                        </div>
                        <div class="popover_content">
                            <div class="popover_items">
                                <div class="popover_item d-flex align-items-center justify-content-between"
                                    *ngFor="let menuava of getFilteredMenuAvailableTypes();let i=index"
                                    [ngClass]="multiSelectGroupAva == menuava?.menuAvaName && 'active'"
                                    (click)="selectMenuAvaType(menuava);">
                                    {{menuava?.menuAvaName}}
                                    <svg-icon src="/assets/images/icons/tick.svg"
                                        *ngIf="multiSelectGroupAva == menuava?.menuAvaName"></svg-icon>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-3 py-2 py-md-3 border-right border-light d-flex align-items-center">
                <svg-icon src="./assets/images/icons/sort_cyan.svg" class="field_icon"></svg-icon>
                <div [autoClose]="'outside'" [ngbPopover]="popContentCuisi" triggers="manual" #p="ngbPopover"
                    (click)="openPopoverCuissine(p)" (clickOutside)="onClickedOutside($event)" placement="bottom"
                    popoverClass="search_select_popover" class='py-0 px-0 w-100 pl-3'>
                    <span class="_popover_label">Cuissine</span>
                    <span class="d-flex justify-content-end _popover_arrow">
                        <img src="/assets/images/Path.png" class="padding-left-image pr-3 justify-content-between" />
                    </span>
                    <div class="all">{{selectedMenuCuisinneName}}</div>
                    <ng-template #popContentCuisi>
                        <div class="popover_search">
                            <svg-icon src="/assets/images/icons/search.svg"></svg-icon>
                            <input type="text" placeholder='Search' [(ngModel)]="searchGroupCus" />
                        </div>
                        <div class="popover_content">
                            <div class="popover_items">
                                <div class="popover_item d-flex align-items-center justify-content-between"
                                    *ngFor="let cuissine of getFilteredMenuCuissineTypes(); let i=index"
                                    [ngClass]="multiSelectGroupCuis == cuissine?.menuCuiName && 'active'"
                                    (click)="selectMenuCuissineType(cuissine)">
                                    {{cuissine?.menuCuiName}}
                                    <svg-icon src="/assets/images/icons/tick.svg"
                                        *ngIf="multiSelectGroupCuis == cuissine?.menuCuiName"></svg-icon>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-5 py-2 py-md-3 d-flex align-items-center">
                <form class="search_form w-100">
                    <svg-icon src="./assets/images/icons/search.svg"></svg-icon>
                    <input type="text" name="searchText" id="searchText" class="search_field"
                        placeholder="Search by Menu Name" [(ngModel)]="searchText" (keyup)="searchByText(searchText)"
                        (search)="searchByText(searchText)" #searchcontact="ngModel">
                    <button type="submit" class="d-none"></button>
                </form>
            </div>
        </div>
    </div>

    <div class="mb-4 mb-md-5 d-flex align-items-center justify-content-between" *ngIf="newmainMenuList?.length">
        <h3 class="h6 font-weight-bold text-dark mb-0">{{totalRows}} Menu{{totalRows > 1 ? ' item(s)' : null}}</h3>
        <div class="d-flex align align-items-center column-gap-2" *ngIf="foodvendorRemove">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="masterSelectedMenus" name="list_name"
                    value="m1" (change)="checkUncheckAll()" id="all_list_name">
                <label class="custom-control-label cursor-pointer" for="all_list_name">Select all</label>
            </div>
            <div ngbDropdown *ngIf="showDropdown">
                <button type="button" class="dropdown_dots px-2 text-primary" id="download_dropdown" ngbDropdownToggle>
                    <svg-icon src="../../../assets/images/icons/more_dots.svg"
                        [svgStyle]="{ 'height.px':20 }"></svg-icon>
                </button>
                <div ngbDropdownMenu aria-labelledby="download_dropdown">
                    <button ngbDropdownItem (click)="openModal(onlyMenuIds, fromListPage)">Remove Selected</button>
                </div>
            </div>
        </div>
    </div>

    <div class="row row-gap-4" *ngIf="newmainMenuList?.length">
        <div class="col-12 col-md-6 col-lg-4 col-xl-3" *ngFor="let foodmenu of newmainMenuList | paginate: { itemsPerPage: 12,
            currentPage: page, totalItems:newmainMenuList?.length }; let i=index">
            <div class="bg-lighter p-3 rounded d-flex align-items-start column-gap-2 h-100">
                <div class="custom-control custom-checkbox flex-shrink-0 mt-1" *ngIf="foodvendorRemove">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="foodmenu.isSelected"
                        name="list_name" [id]="foodmenu.foodCourtVendorMenuId + 'list_name'"
                        value="{{foodmenu.foodCourtVendorMenuId}}" (change)="isAllSelected()">
                    <label [for]="foodmenu.foodCourtVendorMenuId + 'list_name'"
                        class="custom-control-label cursor-pointer"></label>
                </div>
                <div class="w-100">
                    <h3 class="font-weight-bold text-primary h5 mb-1 mb-md-2 cursor-pointer d-flex"
                        (click)="goToMenuDetails(foodmenu.foodCourtVendorMenuId)">
                        <span class="mr-3">{{foodmenu?.foodName}}</span>
                        <svg-icon src="./assets/images/icons/veg_or_non.svg"
                            [ngClass]="foodmenu?.foodType==='Veg' ? 'text-success' : 'text-danger'" class="ml-auto"
                            [svgStyle]="{ 'width.px':20 }"></svg-icon>
                    </h3>
                    <div>
                    </div>
                    <p class="small mb-1" *ngIf="foodmenu?.isAvailable=='Available'">Status: <strong
                            class="text-success">Available</strong></p>
                    <p class="small mb-1" *ngIf="foodmenu?.isAvailable=='Not Available'">Status: <strong
                            class="text-danger">Not Available</strong></p>
                    <p class="small mb-1">Menu Type: {{foodmenu?.foodType}}</p>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center pagination-section mt-4" *ngIf="newmainMenuList?.length > 12">
        <div class="custom_pagination mt-4 mt-md-5 small">
            <div class="border border-light">
                <pagination-controls class="pagination" (pageChange)="handelMenuList($event)"
                    class="d-flex justify-content-center">
                </pagination-controls>
                <div class="page_numbers">
                    {{indexPage}}/{{paginationCount(newmainMenuList?.length)}}</div>
                <!-- <div class="page_numbers">
                    {{paginationCount(newmainMenuList?.length)}}/{{indexPage}}</div> -->
            </div>
        </div>
    </div>

    <div *ngIf="!newmainMenuList?.length" class="no_data_found d-flex flex-column align-items-center justify-content-center text-center pb-4">
        <h3>No Data Found</h3>
        <img src="../../../../assets/images/error-page/empty-state.png" alt="empty state image" loading="lazy" />
    </div>
</div>